module.exports = __webpack_public_path__ + "img/product-express-one.95c0a54.png";